




















































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import Widget from "@/components/common/Widget.vue";
import DataTable from "@/components/table/DataTable.vue";
import api from "../../api";
import store from "../../store";
import { strSlugify } from "@/helper/utils";
import { isEmailValid } from "@/helper/utils";
import lodash from "lodash";
import SelectFilter from "@/components/common/SelectFilter.vue";
import { getAuthTypeText } from "@/auth";

declare const $: any;

@Component({ components: { Breadcrumb, Widget, DataTable, SelectFilter } })
export default class UknowAgencies extends Vue {
  tableColums = [
    {
      label: "ID",
      prop: "customernumber",
      bodyCellClass: "text-left",
      sortable: true,
    },
    {
      label: "Kanzleiname",
      prop: "companyname",
      bodyCellClass: "text-left",
      sortable: true,
    },
    {
      label: "Kontaktperson Nachname",
      prop: "agencyManager",
      bodyCellClass: "text-left",
      sortable: true,
    },
    {
      label: "Kontaktperson Vorname",
      prop: "agencyEmail",
      bodyCellClass: "text-left",
      sortable: true,
    },
    {
      label: "Auth verfahren",
      prop: "authTypeText",
      bodyCellClass: "text-left",
      sortable: true,
    },
  ];
  perPageList = [25, 50, 100, 250];
  perPage = 25;
  orderby = "id";
  orderDirection = "asc";
  totalItems = 0;
  offsetPage = 0;
  tableRows: any[] = [];
  filteredRows: any[] = [];
  user: any = {
    companyname: "",
    contact_title: "",
    contact_firstname: "",
    contact_lastname: "",
    contact_email: "",
    street: "",
    zip: "",
    city: "",
    country: "DE",
    phone: "",
    fax: "",
    exportactive: false,
    exporteo: false,
    consultantnumber: "",
    flags: 0,
  };
  userId = "";
  userToDelete = "";
  isErrorEmail: boolean = false;

  constructor() {
    super();
    this.getStbs();
  }

  changefilter(val: any, key: string) {
    this.offsetPage = 0;
    this.getStbs();
  }

  getStbs() {
    this.tableRows = [];
    store.dispatch(
      "updateLoading",
      store.state.loading >= 0 ? store.state.loading + 1 : 1
    );
    api
      .getStbs()
      .then((res) => {
        store.dispatch("updateLoading", store.state.loading - 1);
        if (res.data) {
          res.data.forEach((stb: any) => {
            this.tableRows.push({
              customernumber: stb[0],
              companyname: stb[1],
              agencyManager: stb[2],
              agencyEmail: stb[3],
              flags: stb[6] || 0,
              authTypeText: getAuthTypeText(stb[6]),
            });
          });
        }
        this.filteredRows = this.tableRows;
        this.totalItems = this.filteredRows.length;
      })
      .catch((err) => {
        store.dispatch("updateLoading", store.state.loading - 1);
      });
  }

  addModal() {
    this.user = {
      companyname: "",
      contact_title: "",
      contact_firstname: "",
      contact_lastname: "",
      contact_email: "",
      street: "",
      zip: "",
      city: "",
      country: "DE",
      phone: "",
      fax: "",
      exportactive: false,
      exporteo: false,
      consultantnumber: "",
      flags: 0,
    };
    this.userId = "";
    $("#add_modal").modal();
  }

  edit(event: any) {
    this.userId = event.customernumber;
    $("#add_modal").modal();
    store.dispatch(
      "updateLoading",
      store.state.loading >= 0 ? store.state.loading + 1 : 1
    );
    api
      .getStb(event.customernumber)
      .then((res) => {
        store.dispatch("updateLoading", store.state.loading - 1);
        this.user = res.data;
      })
      .catch((err) => {
        store.dispatch("updateLoading", store.state.loading - 1);
      });
  }

  onDeleteModal(event: any) {
    $("#delete_modal").modal();
    this.userToDelete = event.customernumber;
  }
  onExportProgramModal(event: any) {
    const fileName =
      strSlugify(event.customernumber + "-" + event.companyname) + ".zip";
    store.dispatch(
      "updateLoading",
      store.state.loading >= 0 ? store.state.loading + 1 : 1
    );
    api
      .downloadExportProgram(event.customernumber)
      .then((res) => {
        store.dispatch("updateLoading", store.state.loading - 1);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        store.dispatch("updateLoading", store.state.loading - 1);
      });
  }

  deleteItem(event: any) {
    store.dispatch(
      "updateLoading",
      store.state.loading >= 0 ? store.state.loading + 1 : 1
    );
    api
      .deleteStb(this.userToDelete)
      .then((res) => {
        store.dispatch("updateLoading", store.state.loading - 1);
        this.getStbs();
      })
      .catch((err) => {
        store.dispatch("updateLoading", store.state.loading - 1);
      });
  }

  add() {
    this.user = {
      ...this.user,
      companyname: this.user.companyname,
      contact_title: this.user.contact_title,
      contact_firstname: this.user.contact_firstname,
      contact_lastname: this.user.contact_lastname,
      street: this.user.street,
      zip: this.user.zip,
      city: this.user.city,
    };

    if (isEmailValid(this.user.contact_email)) {
      this.isErrorEmail = true;
      return;
    }

    if (this.userId) {
      store.dispatch(
        "updateLoading",
        store.state.loading >= 0 ? store.state.loading + 1 : 1
      );
      api
        .updateStb(this.userId, this.user)
        .then((res) => {
          store.dispatch("updateLoading", store.state.loading - 1);
          this.getStbs();
        })
        .catch((err) => {
          store.dispatch("updateLoading", store.state.loading - 1);
        });
    } else {
      store.dispatch(
        "updateLoading",
        store.state.loading >= 0 ? store.state.loading + 1 : 1
      );
      api
        .postStb(this.user)
        .then((res) => {
          store.dispatch("updateLoading", store.state.loading - 1);
          this.getStbs();
        })
        .catch((err) => {
          store.dispatch("updateLoading", store.state.loading - 1);
        });
    }

    $("#add_modal").modal("hide");
  }

  toggle() {
    store.dispatch(
      "updateLoading",
      store.state.loading >= 0 ? store.state.loading + 1 : 1
    );
    api
      .toggleStb(this.user.customernumber, this.user.active)
      .then((res) => {
        api
          .getStb(this.user.customernumber)
          .then((res) => {
            store.dispatch("updateLoading", store.state.loading - 1);
            this.user = res.data;
          })
          .catch((err) => {
            store.dispatch("updateLoading", store.state.loading - 1);
          });
      })
      .catch((err) => {
        store.dispatch("updateLoading", store.state.loading - 1);
      });
  }

  search(event: any) {
    if (event) {
      this.filteredRows = this.tableRows.filter((row) => {
        return (
          row.agencyEmail.toLowerCase().includes(event.toLowerCase()) ||
          row.agencyManager.toLowerCase().includes(event.toLowerCase()) ||
          row.customernumber.toLowerCase().includes(event.toLowerCase()) ||
          row.companyname.toLowerCase().includes(event.toLowerCase())
        );
      });
    } else {
      this.filteredRows = this.tableRows;
    }
  }

  changeSortDirection(val: any) {
    this.orderDirection = val;
  }

  changeSortProperty(val: any) {
    this.orderby = val;
    this.orderDirection = "asc";
  }

  changePerPage(val: any): void {
    if (val) {
      let offsetPage = val - 1;
      if (offsetPage !== this.offsetPage) {
        this.offsetPage = offsetPage;
      }
    }
  }
}
